import { Checkbox, TableCell, TableRow, TableHead, TableSortLabel } from '@mui/material'
import { MouseEvent as ReactMouseEvent, ChangeEventHandler } from 'react'
import { useLocation } from 'react-router-dom'
import { omitKeys } from 'utils/utils'

const CELLS = [
  {
    id: 'document_name',
    label: '名前',
    pages: ['deleted', 'home', 'task'],
  },
  {
    id: 'document_type',
    label: '文書タイプ',
    pages: ['deleted', 'home', 'task'],
  },
  {
    id: 'document_status_no',
    label: 'ステータス',
    pages: ['home', 'task'],
  },
  {
    id: 'verify_users',
    label: '',
    pages: ['task'],
  },
  {
    id: 'schedule_doc_deletion',
    label: '削除予定日',
    pages: ['deleted'],
  },
  {
    id: 'insert_time',
    label: '登録日時',
    pages: ['task'],
  },
  {
    id: 'update_time',
    label: '更新日時',
    pages: ['deleted', 'home', 'task'],
  },
  {
    id: 'update_user_name',
    label: '更新者',
    pages: ['deleted', 'home'],
  },
  {
    id: 'sub_group.group_name',
    label: 'グループ',
    pages: ['deleted', 'home'],
  },
  {
    id: 'assignee.user_name',
    label: '担当',
    pages: ['deleted', 'home'],
  },
]

const getHeadCells = (page) => {
  return CELLS.filter((x) => x.pages.includes(page)).map((x) => omitKeys(x, 'pages'))
}

interface Props {
  numSelected: number
  onRequestSort: (event: ReactMouseEvent<HTMLSpanElement, MouseEvent>, property: string) => void
  onSelectAllClick: ChangeEventHandler<HTMLInputElement>
  order: 'asc' | 'desc'
  orderBy: string
  rowCount: number
}

function DocumentsTableHead(props: Props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props

  const path = useLocation().pathname
  const page = path.match('deleted') ? 'deleted' : path.match('verify') ? 'task' : 'home'
  const headCells = getHeadCells(page)

  const cellElements = headCells.map((headCell) => {
    const { id, label } = headCell

    return (
      <TableCell key={id} sortDirection={orderBy === id ? order : false}>
        <TableSortLabel
          active={orderBy === id}
          direction={orderBy === id ? order : 'asc'}
          onClick={(event) => {
            onRequestSort(event, id)
          }}
          sx={{ p: 0 }}
        >
          {label}
        </TableSortLabel>
      </TableCell>
    )
  })

  return (
    <TableHead data-testid="table-head-documents-list">
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            size="small"
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all documents' }}
          />
        </TableCell>
        {cellElements}
      </TableRow>
    </TableHead>
  )
}

export default DocumentsTableHead
